import { type MCPServerInfo } from '../../types';

const ZapierServer: MCPServerInfo = {
  serverId: 'ZAPIER',
  name: 'Zapier',
  slug: 'zapier',
  description:
    'Search knowledge across your apps and execute real-world actions by connecting Claude with the 8,000 apps on Zapier. Run workflows like sending emails, updating CRMs, scheduling meetings, and more all within Claude.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.zapier.com/sse',
    transport: 'SSE'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default ZapierServer;
